import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {DIAGRAM_VERSION_STATES_ENUM} from '../models/diagram-version.constant';

@Pipe({
  name: 'getVersionTagColor',
  standalone: true
})
export class GetVersionTagColorPipe implements PipeTransform {
  private ready = this.translateSvc.instant('VERSIONING.DIAGRAM_STATE_READY');
  private master = this.translateSvc.instant('VERSIONING.DIAGRAM_STATE_PUBLISHED');
  private archive = this.translateSvc.instant('VERSIONING.DIAGRAM_STATE_ARCHIVE');
  private neverPublished = this.translateSvc.instant('VERSIONING.DIAGRAM_STATE_NEVER_PUBLISHED');
  private beingAuthorised = this.translateSvc.instant('VERSIONING.BEING_AUTHORISED_DIAGRAM_LABEL');
  private cancelled = this.translateSvc.instant('VERSIONING.CANCELLED_DIAGRAM_LABEL');

  constructor(private translateSvc: TranslateService) {}

  transform(state: string): string {
    switch (state) {
      case DIAGRAM_VERSION_STATES_ENUM.DRAFT:
        return 'green';

      case DIAGRAM_VERSION_STATES_ENUM.READY:
        return 'yellow';

      case DIAGRAM_VERSION_STATES_ENUM.BEING_AUTHORISED:
        return 'warn';

      case DIAGRAM_VERSION_STATES_ENUM.MASTER:
        return 'primary';

      case DIAGRAM_VERSION_STATES_ENUM.ARCHIVE:
        return 'accent';
    }
  }
}
